import { render, staticRenderFns } from "./RenewUpgradeTab.vue?vue&type=template&id=e5b21c78"
import script from "./RenewUpgradeTab.vue?vue&type=script&lang=js"
export * from "./RenewUpgradeTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports